import React from "react";
import { CardContent, Typography, Box, Stack } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";

function Assets({ responseFem, responseBem }) {
  const navigate =useNavigate()
  return (
    <>
      <StyledCard variant="outlined">
        <CardContent>
          <Typography
            mb={1.5}
            variant="h5"
            fontWeight={700}
            color={"text.primary"}
          >
            Assets
          </Typography>
          <Stack
            direction={"row"}
            useFlexGap
            flexWrap={"wrap"}
            spacing={2}
          >
            <StyledCard
              variant="outlined"
              sx={{ flexGrow: 1, cursor: "pointer" }}
            >
              <CardContent onClick={() => {navigate("/assetsFEM")}}>
                <Typography mb={1.5} variant="title2" color={"text.primary"}>
                  FEMS
                </Typography>
                <Stack
                  direction="row"
                  useFlexGap
                  flexWrap={{ xs: "wrap", lg: "nowrap" }}
                  spacing={2}
                >
                  <Box flexGrow={1}>
                    <Typography mb={1} color={"text.primary"}>
                      Authorised
                    </Typography>
                    <Typography variant="h1" color={"success.dashboard"}>
                      {responseFem?.assetAuthorizedCount}
                    </Typography>
                  </Box>
                  <Box flexGrow={1}>
                    <Typography mb={1} color={"text.primary"}>
                      Unauthorised
                    </Typography>
                    <Typography variant="h1" color={"error.dashboard"}>
                      {responseFem?.assetUnauthorizedCount}
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </StyledCard>
            <StyledCard
              variant="outlined"
              sx={{ flexGrow: 1, cursor: "pointer" }}
            >
              <CardContent onClick={() => {navigate("/assetsBEM")}}>
                <Typography mb={1.5} variant="title2" color={"text.primary"}>
                  BEMS
                </Typography>
                <Stack
                  direction="row"
                  useFlexGap
                  flexWrap={{ xs: "wrap", lg: "nowrap" }}
                  spacing={2}
                >
                  <Box flexGrow={1}>
                    <Typography mb={1} color={"text.primary"}>
                      Authorised
                    </Typography>
                    <Typography variant="h1" color={"success.dashboard"}>
                      {responseBem?.assetAuthorizedCount}
                    </Typography>
                  </Box>
                  <Box flexGrow={1}>
                    <Typography mb={1} color={"text.primary"}>
                      Unauthorised
                    </Typography>
                    <Typography variant="h1" color={"error.dashboard"}>
                      {responseBem?.assetUnauthorizedCount}
                    </Typography>
                  </Box>
                </Stack>
              </CardContent>
            </StyledCard>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default Assets;
